<div class="eip-mxy-5">
  <div mat-dialog-content class="">
      <div class="row com-doc-head eip-mt-20">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 eip-pl-10">
              <mat-button-toggle-group aria-label="Numbering Format" class="com-semiauto" [value]='messageFormat' (change)="onMessageFormatChange($event.value)">
                  <mat-button-toggle value="Mail">New Message</mat-button-toggle>
                  <mat-button-toggle value="Register Incoming Message">Register Incoming Message</mat-button-toggle>
              </mat-button-toggle-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 eip-pr-10">
              <div class="d-flex justify-content-end align-items-center">
                  <div>
                      <mat-label class="font-weight-bold eip-mr-20">Numbering Format : </mat-label>
                      <mat-button-toggle-group aria-label="Numbering Format" class="com-semiauto" [value]='numFormat' (change)="onNumFormatChange($event.value)">
                          <mat-button-toggle value="Semi" aria-checked="true">Semi</mat-button-toggle>
                          <mat-button-toggle value="Manual" *ngIf="canManualNo">Manual</mat-button-toggle>
                          <mat-button-toggle value="Auto">Auto</mat-button-toggle>
                      </mat-button-toggle-group>
                  </div>
                  <span class="eip-pl-20 "> | </span>
                  <div class=""> <i class="fa fa-send fs-24 eip-link com-arrow " aria-hidden="true" id="btnSend" (click)="sendMessage()"></i>
                  </div>
              </div>
          </div>
      </div>
      <mat-accordion>
          <mat-expansion-panel [expanded]="panelOpenState">
              <mat-expansion-panel-header [expandedHeight]="'50px'" [collapsedHeight]="'50px'">
                  <mat-panel-title id="accAccountCodeMaster">
                      <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                          <div class="title-container d-flex align-items-center">
                              <mat-label>Message Number | </mat-label>
                              <mat-label class="eip-ml-10" [innerHtml]="getMessageNumber()"></mat-label>
                          </div>
                          <div class="acc-icon-container align-items-center d-flex eip-mr-0">
                              <i title="Attachment" class="fa fa-paperclip fs-18" aria-hidden="true" id="ibtINDVCollapseAll" (click)="$event.stopPropagation();showAttachmentList($event)"></i>
                              <kendo-popup class="order-popup eip-mr-15" popupClass="kendo-popup kendo-popup-right kp-pos-right" [anchor]="anchorElementPopup" [anchorAlign]="anchorAlignRight" [popupAlign]="popupAlignRight" (anchorViewportLeave)="IsShowAttachmentList = false" *ngIf="IsShowAttachmentList" (click)="closeAttachmentList()">
                                  <div class="kp-body">
                                      <div class="d-flex">
                                          <p title="Document" class="eip-pxy-10" (click)="$event.stopPropagation();showDocumentCart()">
                                              Document</p>
                                      </div>
                                      <div class="d-flex" *ngIf="mailType!='Request For Information'">
                                          <p title="Message" class="eip-pl-10 eip-pr-10 eip-pb-10 eip-mb-10" (click)="$event.stopPropagation();showMessageCart()">Message</p>
                                      </div>
                                  </div>
                              </kendo-popup>
                          </div>
                      </div>
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="eip-mt-20 eip-mb-10">
                  <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
              </div>
              <form [formGroup]="messageForm">
                  <div class="eip-mt-20 eip-mb-10">
                      <div class="row">
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <mat-form-field style="width: 100%;">
                                  <mat-label>Message Serial No</mat-label>
                                  <input matInput formControlName="txtMsgSerialNo" required (keypress)="omit_special_char($event)">
                              </mat-form-field>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="isShowSerialNo">
                              <mat-form-field>
                                  <mat-label>Serial No</mat-label>
                                  <input matInput formControlName="txtSerialNo" [maxlength]="serialNoLength" required type="number" (keypress)="omit_special_char($event)">
                              </mat-form-field>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Mail Type*" formControlName="autoMailType" required setId="ddlMailType" ShowTextValueField='N' [dataSource]='mailTypeList' [IsCascading]='true' (valueChange)='setMessageValues($event,"ddlMailType")'>
                              </EIPAutoComplete>
                              <mat-error *ngIf="messageForm.get('autoMailType').touched && messageForm.get('autoMailType').hasError('required')">
                                  Mail Type is required
                              </mat-error>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <mat-form-field floatLabel="always" appearance="none">
                                  <mat-label>Confidential</mat-label>
                                  <mat-slide-toggle  color="primary" formControlName="lblIsConfidential"></mat-slide-toggle>
                                  <textarea matInput hidden></textarea> 
                              </mat-form-field>
                          </div>
                      </div>
                      <div class="row" *ngIf="messageFormat == 'Register Incoming Message'||mailType=='Request For Information'">
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                              <EIPAutoComplete TextField="memberName" ValueField="memberId" WaterMarkText="From*" formControlName="autoMailFrom" required setId="ddlMailFrom" ShowTextValueField='N' [dataSource]='mailFromList' [IsCascading]='true' (valueChange)='setMessageValues($event,"ddlMailFrom")'>
                              </EIPAutoComplete>
                          </div>
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="messageFormat == 'Register Incoming Message'">
                              <EIPDatePicker setid="txtRegisterDate" WaterMark="Sent On" [Value]=sentdatevalue (selectedDate)='getSentOnValue($event)' (selectedTime)='getTimeValue($event)'>
                              </EIPDatePicker>
                              <mat-error *ngIf="this.isSentDateInvalid">
                                  Sent On is required
                              </mat-error>
                          </div>
                      </div>
                  </div>
              </form>
              <form [formGroup]="messageGroupForm">
                  <div class="row back-row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <EIPAutoComplete ShowTextValueField='N' setId="mgList" formControlName="formMGList" TextField="groupDescription"  ValueField="groupId" WaterMarkText="Message Group" [IsCascading]='true' [dataSource]='mgList' (valueChange)='onMGValueChange($event,"formMGList")' [SingleValueBind]="false">
                          </EIPAutoComplete>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-xs-12">
                          <div class="view-info eip-mb-20">
                              <p class="view-label">Response Required</p>
                              <mat-button-toggle-group aria-label="Numbering Format" class="com-semiauto" [value]='responseRequired' (change)="onResponseRequiredChange($event.value)">
                                  <mat-button-toggle value="Yes">Yes</mat-button-toggle>
                                  <mat-button-toggle value="No">No</mat-button-toggle>
                              </mat-button-toggle-group>
                          </div>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-6 col-sm-12 col-xs-12">
                          <mat-form-field style="width: 100%;" *ngIf="responseRequired=='Yes'">
                              <mat-label>No Of Days</mat-label>
                              <input matInput formControlName="txtNoOfDays" (change)="addDays()" type="number" Min="1" Max="30">
                          </mat-form-field>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12" *ngIf="responseRequired=='Yes'">
                          <EIPDatePicker setid="txtResponseDate" WaterMark="Response Date" [Value]=datevalue [IsDateDisabled]="IsDisabled" (selectedDate)='getValue($event)' (selectedTime)='getTimeValue($event)'>
                          </EIPDatePicker>
                          <mat-error *ngIf="this.isRevisedDateInvalid">
                              Response Date is required
                          </mat-error>
                      </div>
                  </div>
                  <div class="row back-row">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <mat-form-field style="width: 100%;">
                              <mat-label>To</mat-label>
                              <mat-chip-list #toChipList formControlName="toMembers">
                                  <ng-container *ngFor="let member of toMembers">
                                      <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removeTo(member)">
                                          {{member.memberName}}
                                          <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                      </mat-chip>
                                  </ng-container>
                                  <input #toInput (focus)="matToAutoComplete.showPanel = true" formControlName="toMembersCtrl" [matAutocomplete]="toauto" [matChipInputFor]="toChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                              </mat-chip-list>
                              <mat-autocomplete #toauto="matAutocomplete">
                                  <mat-option *ngFor="let member of toFilteredMembers | async" [value]="member">
                                      <div (click)="optionClicked($event, member,'to')">
                                          <mat-checkbox [checked]="isMemberSelected(member,'to')" (change)="toggleToSelection(member)" (click)="$event.stopPropagation()">
                                              {{member.memberName}}
                                          </mat-checkbox>
                                      </div>
                                  </mat-option>
                              </mat-autocomplete>
                          </mat-form-field>
                      </div>
                  </div>
                  <div class="row back-row">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <mat-form-field style="width: 100%;">
                              <mat-label>Cc</mat-label>
                              <mat-chip-list #ccChipList formControlName="ccMembers">
                                  <ng-container *ngFor="let member of ccMembers">
                                      <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removeCc(member)">
                                          {{member.memberName}}
                                          <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                      </mat-chip>
                                  </ng-container>
                                  <input #ccInput (focus)="matCcAutoComplete.showPanel = true" formControlName="ccMembersCtrl" [matAutocomplete]="ccauto" [matChipInputFor]="ccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                              </mat-chip-list>
                              <mat-autocomplete #ccauto="matAutocomplete">
                                  <mat-option *ngFor="let member of ccFilteredMembers | async" [value]="member">
                                      <div (click)="optionClicked($event, member,'cc')">
                                          <mat-checkbox [checked]="isMemberSelected(member,'cc')" (change)="toggleCcSelection(member)" (click)="$event.stopPropagation()">
                                              {{member.memberName}}
                                          </mat-checkbox>
                                      </div>
                                  </mat-option>
                              </mat-autocomplete>
                          </mat-form-field>
                      </div>
                  </div>
                  <div class="row back-row">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <mat-form-field style="width: 100%;">
                              <mat-label>Bcc</mat-label>
                              <mat-chip-list #bccChipList formControlName="bccMembers">
                                  <ng-container *ngFor="let member of bccMembers">
                                      <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removebcc(member)">
                                          {{member.memberName}}
                                          <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                                      </mat-chip>
                                  </ng-container>
                                  <input #bccInput (focus)="matbccAutoComplete.showPanel = true" formControlName="bccMembersCtrl" [matAutocomplete]="bccauto" [matChipInputFor]="bccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                              </mat-chip-list>
                              <mat-autocomplete #bccauto="matAutocomplete">
                                  <mat-option *ngFor="let member of bccFilteredMembers | async" [value]="member">
                                      <div (click)="optionClicked($event, member,'bcc')">
                                          <mat-checkbox [checked]="isMemberSelected(member,'bcc')" (change)="togglebccSelection(member)" (click)="$event.stopPropagation()">
                                              {{member.memberName}}
                                          </mat-checkbox>
                                      </div>
                                  </mat-option>
                              </mat-autocomplete>
                          </mat-form-field>
                      </div>
                  </div>
              </form>
              <form [formGroup]="messageContentForm">
                  <div class="row eip-pl-20 eip-pr-20 eip-mt-20">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <mat-form-field style="width: 100%;">
                              <input matInput formControlName="txtMailSubject" placeholder='Subject' required>
                          </mat-form-field>
                      </div>
                      <kendo-editor [value]="mailContent" formControlName="editor" style="height: 245px; width:100%">
                          <kendo-toolbar>
                              <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                              <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                              <kendo-toolbar-buttongroup>
                                  <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                              </kendo-toolbar-buttongroup>
                              <kendo-toolbar-buttongroup>
                                  <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                              </kendo-toolbar-buttongroup>
                              <kendo-toolbar-buttongroup>
                                  <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                              </kendo-toolbar-buttongroup>
                              <kendo-toolbar-buttongroup>
                                  <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                                  <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                              </kendo-toolbar-buttongroup>
                              <kendo-toolbar-buttongroup>
                                  <kendo-toolbar-button text="Signature" (click)="openSignaturePopup()"></kendo-toolbar-button>
                                  <kendo-toolbar-button icon="k-icon k-i-arrow-60-down" *ngIf="signatureList.length>0" (click)="showSignList($event)">
                                  </kendo-toolbar-button>
                              </kendo-toolbar-buttongroup>
                          </kendo-toolbar>
                      </kendo-editor>
                      <kendo-popup class="order-popup" popupClass="kendo-popup kendo-popup-left kp-pos-left" [anchor]="anchorElementPopup" [anchorAlign]="anchorAlignLeft" [popupAlign]="popupAlignLeft" (anchorViewportLeave)="IsShowPopup = false" *ngIf="IsShowPopup" (click)="closeSignList()">
                          <div class="kp-body eip-pl-10 eip-pr-10 eip-pt-10">
                              <div class="search-row eip-mb-10" style="border-bottom: 1px solid #7ac3ff;" *ngFor="let sign of signatureList; let index = index">
                                  <div class="sign-wrapper" (click)="selectSignature(sign)">
                                      <div class="main-sign">
                                          <span><span class="num">{{index+1}}</span><span class="signone ff-2 fs-12">{{sign.signatureName}}</span></span>
                                      </div>
                                      <div class="d-flex">
                                          <div class="sign-content" [innerHTML]="sign.signatureText">
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </kendo-popup>
                  </div>
              </form>
              <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="documentList.length>0">
                  <kendo-grid #docGrid [kendoGridBinding]="documentList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
                      <ng-template kendoPagerTemplate>
                          <div class="k-pager-left">
                              <kendo-pager-info></kendo-pager-info>
                          </div>
                          <div class="k-pager-right">
                              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                              <kendo-pager-input></kendo-pager-input>
                              <kendo-pager-next-buttons></kendo-pager-next-buttons>
                          </div>
                      </ng-template>
                      <ng-template kendoGridToolbarTemplate>
                          <div class="k-grid-toolbar-content d-flex align-content-center">
                              <div class="flex-grow-1 title-container">
                                  <p class="title">ATTACHMENT - Documents</p>
                              </div>
                          </div>
                      </ng-template>
                      <kendo-grid-column title="Sl.No." filterable="false" width="60">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                              {{rowIndex+1}}
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="documentNo" title="Document Number" width="150">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">
                                  {{dataItem.documentNo}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="title" title="Title" width="150">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span>
                                  <span class="no-wrap" eipTooltip="title" eipTooltipPosition="auto">
                                      {{dataItem.title}}
                                  </span>
                              </span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="revision" title="Revision" width="50" id="glblASRFRequiredQuantity" [minResizableWidth]="90">
                          <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                              Revision
                          </ng-template>
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span>{{dataItem.revision}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column title="Created By" width="90">
                          <ng-template kendoGridCellTemplate let-dataItem>
                              <span>
                                  <span *ngIf="dataItem.createdByName" class="no-wrap" eipTooltip="Created By" eipTooltipPosition="auto">
                                      {{dataItem.createdByName}}
                                  </span>
                                  <span *ngIf="dataItem.createdBy" class="no-wrap" eipTooltip="Created By" eipTooltipPosition="auto">
                                      {{dataItem.createdBy}}
                                  </span>
                              </span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="action" title="Actions" width="50">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <div #divIcon class=" icon-container d-flex align-items-center">
                                  <i class="fa fa-trash" title="Delete" (click)="removeDocument(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                              </div>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
              <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="messageList.length>0">
                  <kendo-grid #docGrid [kendoGridBinding]="messageList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
                      <ng-template kendoPagerTemplate>
                          <div class="k-pager-left">
                              <kendo-pager-info></kendo-pager-info>
                          </div>
                          <div class="k-pager-right">
                              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                              <kendo-pager-input></kendo-pager-input>
                              <kendo-pager-next-buttons></kendo-pager-next-buttons>
                          </div>
                      </ng-template>
                      <ng-template kendoGridToolbarTemplate>
                          <div class="k-grid-toolbar-content d-flex align-content-center">
                              <div class="flex-grow-1 title-container">
                                  <p class="title">ATTACHMENT - Messages</p>
                              </div>
                          </div>
                      </ng-template>
                      <kendo-grid-column title="Sl.No." filterable="false" width="60">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                              {{rowIndex+1}}
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="messageNumber" title="Message Number" width="150">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">
                                  {{dataItem.messageNumber}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="messageSubject" title="Title" width="150">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="title" eipTooltipPosition="auto">
                                {{dataItem.messageSubject}}
                            </span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="from" title="From" width="90" id="glblASRFRequiredQuantity" [minResizableWidth]="90">
                          <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                              From
                          </ng-template>
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <span>{{dataItem.from}}</span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="messageTypeDesc" title="Mail Type" width="50"> </kendo-grid-column>
                      <kendo-grid-column field="action" title="Actions" width="50">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                              <div #divIcon class=" icon-container d-flex align-items-center">
                                  <i class="fa fa-trash" title="Delete" (click)="removeMessage(dataItem)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                              </div>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
              <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="attachmentsList.length>0">
                  <kendo-grid [data]="attachmentsList" id="grvFileList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
                      <ng-template kendoPagerTemplate>
                          <div class="k-pager-left">
                              <kendo-pager-info></kendo-pager-info>
                          </div>
                          <div class="k-pager-right">
                              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                              <kendo-pager-input></kendo-pager-input>
                              <kendo-pager-next-buttons></kendo-pager-next-buttons>
                          </div>
                      </ng-template>
                      <ng-template kendoGridToolbarTemplate>
                          <div class="k-grid-toolbar-content d-flex align-content-center">
                              <div class="flex-grow-1 title-container">
                                  <p class="title">ATTACHMENT - Files</p>
                              </div>
                          </div>
                      </ng-template>
                      <kendo-grid-column title="Sl.No" width="20">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                              {{rowIndex+1}}
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="fileName" title="File Name" width="200">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.fileFullName}}" eipTooltipPosition="auto">
                                {{dataItem.fileName + '.'+ dataItem.fileExtension}}
                            </span>
                          </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column title="Actions" width="30" class="text-center">
                          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                              <div class="icon-container d-flex align-items-center">
                                  <i class="fa fa-trash" title="Delete" (click)="deleteFile(rowIndex)" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                              </div>
                          </ng-template>
                      </kendo-grid-column>
                  </kendo-grid>
              </div>
          </mat-expansion-panel>
      </mat-accordion>
  </div>
  <div mat-dialog-actions>
      <div class="row justify-content-end flex-grow-1">
          <button class="btn btn-primary" id="btnBrowse" (click)="clickLocalAttachment()"><i class="fa fa-paperclip" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Attach Files</button>
          <button class="btn btn-secondary" id="btnsaveAllDocument" (click)="saveMessage()"><i class="fa fa-save-as" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save As Draft</button>
          <button class="btn btn-primary" id="btnSave" (click)="sendMessage()"><i class="fa fa-send" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Send</button>
      </div>
  </div>
  <p>{{messageList}}</p>
</div>